import { connect } from 'react-redux';
import { RootState } from '../reducers/root';
import { Homepage } from '../components/Homepage';

const mapStateToProps = (state: RootState) => ({
  window: state.AppState.window
});

export default connect(mapStateToProps)(Homepage);
